import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCommentFile } from '../../api/comment-files';

export const getCommentFileAsync = createAsyncThunk(
  'getCommentFiles/getCommentFile',
  getCommentFile
);
